import { takeEvery, put, call } from 'redux-saga/effects';

import { handleApiErrors } from '../actions/actionsUtils';
import actions from '../constants/actions';
const { API } = actions;

function* fetchData(action) {
  // eslint-disable-next-line
  const { type, types, api, params, ...rest } = action;

  if (types.length !== 3) {
    throw new Error('Expected an array of three action types.');
  }

  const [REQUEST, SUCCESS, FAILURE] = types;

  yield put({ type: REQUEST, ...rest });

  try {
    const data = yield call(api, ...params);
    yield put({
      type: SUCCESS,
      data,
      params,
      ...rest,
    });
  } catch (error) {
    yield put({
      type: FAILURE,
      error,
      params,
      ...rest,
    });
    yield put(handleApiErrors(error));
  }
}

export default function* apiSaga() {
  yield takeEvery(API, fetchData);
}
